"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identifier = void 0;
var Identifier;
(function (Identifier) {
    let Interface;
    (function (Interface) {
        Interface.create = ({ name }) => ({
            class: "interface",
            name
        });
    })(Interface = Identifier.Interface || (Identifier.Interface = {}));
    let Struct;
    (function (Struct) {
        Struct.create = ({ name, scope }) => (Object.assign({ class: "struct", name }, (scope
            ? { container: Identifier.Interface.create({ name: scope }) }
            : {})));
    })(Struct = Identifier.Struct || (Identifier.Struct = {}));
    let UserDefinedValueType;
    (function (UserDefinedValueType) {
        UserDefinedValueType.create = ({ name, scope }) => (Object.assign({ class: "udvt", name }, (scope
            ? { container: Identifier.Interface.create({ name: scope }) }
            : {})));
    })(UserDefinedValueType = Identifier.UserDefinedValueType || (Identifier.UserDefinedValueType = {}));
    Identifier.toReference = (identifier) => {
        if (identifier.container) {
            return `${identifier.class}--${identifier.name}--${identifier.container.name}`;
        }
        return `${identifier.class}--${identifier.name}`;
    };
})(Identifier = exports.Identifier || (exports.Identifier = {}));
//# sourceMappingURL=identifier.js.map